import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { loadComponentTranslations } from '../../funcs/lang-loader';

@Component({
  selector: 'app-footer',
  imports: [RouterLink, TranslateModule, FormsModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  public selectedLanguage: string = 'en';

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,

    private _translateService: TranslateService,
    private _http: HttpClient,
  ) {}
  public changeLanguage(e: any): void {
    if (!this.isBrowser()) return;

    localStorage.setItem('language', this.selectedLanguage);
    this._translateService.use(this.selectedLanguage);
    window.location.reload();
  }

  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  public ngOnInit(): void {
    // ✅ Language (SSR-safe default)

    let lang = this._translateService.currentLang || 'en';

    loadComponentTranslations(
      this._http,
      this._translateService,
      'controls/footer',
      this.isBrowser(),
    ).subscribe({
      next: () => {},
      error: () => {},
    });
    this.selectedLanguage = 'en';

    if (this.isBrowser()) {
      this.selectedLanguage = localStorage.getItem('language') || 'en';
    }
  }
}
